<template>
    <div class="card">
        <div class="card-header">
            <div class="row">
                <div class="col-12">
                    <np-checkbox
                                 :id="`${id}_selected`"
                                 :name="`${name}[selected]`"
                                 :no-wrapper="true"
                                 :disabled="itemIsDisabled(bundle_item)"
                                 :description="bundle_item.service.service_name"
                                 :checked="itemIsSelected(bundle_item)"
                                 @change="toggleThirdPartyEquipment(bundle_item)"
                                 v-model="bundle_item.is_boarding_activated">
                    </np-checkbox>
                </div>
            </div>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-12" style="text-align: center">
                    <img width="auto" height="80"  :src="getBundleItemServiceFirstImage(bundle_item)" class="avatar-small">
                </div>
                <div class="col-12">
                    <div class=""  v-if="itemHasDescription(bundle_item)">
                        <span class="labelLook boldText">{{lang('description')}}</span>
                        <np-show-less
                            :id="id"
                            :description="bundle_item.service.service_description" >
                        </np-show-less>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-7 col-lg-7">
                    <div class="" v-if="itemHasFeatures(bundle_item)">
                        <div class="row">
                            <div class="col-lg-12 col-md-12 col-12"
                                        v-if="isSelectedFeature(baxNumberApiCode) && (!!baxNumber && !!baxNumber.is_visible)">
                                <np-input
                                        :label="baxNumber.feature_name"
                                        :placeholder="baxNumber.feature_name"
                                        :name="`${name}_baxNumber`"
                                        :id="`${id}_baxNumber`"
                                        :required="bundle_item.is_boarding_activated === '1' && baxNumber.is_required === '1'"
                                        :help-text="!!baxNumber.help_text ? baxNumber.help_text : ''"
                                        :rules="['alpha_numeric_space']"
                                        :maxlength="baxNumber.max"
                                        :minlength="baxNumber.min"
                                        :disabled="isView"
                                        :check_config="false"
                                        v-model="baxNumber.value">
                                </np-input>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-5 col-lg-5" v-show="false">
                    <div v-if="itemHasServiceCharges(bundle_item, isView)">
                        <span class="labelLook" style="font-weight: bold">{{lang('charges')}}</span>
                        <div class="row">
                            <template v-for="(service_charge, service_charge_idx) in bundle_item.service_charges">
                                <div class="col-12">
                                    <np-checkbox
                                            :id="`${id}_service_charge_${service_charge_idx}_selected`"
                                            :name="`${name}[service_charge][${service_charge_idx}][selected]`"
                                            :no-wrapper="true"
                                            :disabled="!bundleItemIsSelected(bundle_item)"
                                            :description="getServiceChargeDescription(service_charge)"
                                            v-model="service_charge.selected">
                                    </np-checkbox>
                                </div>
<!--                                <div class="col-12" v-else>-->
<!--                                    <span>-->
<!--                                        {{ getServiceCharge(service_charge) }}-->
<!--                                        {{ service_charge.service_frequency !== '1' ? `/${formatServiceFrequency(service_charge.service_frequency)}` : '' }}-->
<!--                                    </span>-->
<!--                                </div>-->
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import utilMixin from "../utils/mixins";
    import applicationMixin from "../utils/application-mixin";
    import equipmentMixin from "../utils/equipment-mixin";
    import {
        NPCheckBox,
        NPEntry,
        NPInput,
        NPNotice, NPPhone,
        NPRadios,
        NPResponsive,
        NPSelect2, NPShowLess,
        NPSkeleton,

    } from "netpify/components";

    export default {
        name: "equipment-service-thirdpartyterminal",
        mixins: [utilMixin, applicationMixin, equipmentMixin],
        components: {
            'np-entry': NPEntry,
            'np-radios': NPRadios,
            'np-input': NPInput,
            'np-select2': NPSelect2,
            'np-responsive': NPResponsive,
            'np-skeleton': NPSkeleton,
            'np-checkbox': NPCheckBox,
            'np-notice': NPNotice,
            'np-phone': NPPhone,
            'np-show-less': NPShowLess,
        },
        data() {
            return {
                baxNumberApiCode: 'baxNumber',
                baxEffectiveDateApiCode: 'baxEffectiveDate',
            }
        },
        props: {
            bundle_item: {
                default() {
                    return {}
                }
            },
            isStandalone: Boolean,
            id: {
                default() {
                    return 'quote' + Math.random().toString()
                }
            },
            name: {
                default() {
                    return 'quote' + Math.random().toString()
                }
            },
            feature_dictionary: {
                type: Object,
                default: () => {
                    return {};
                }
            },
            isView: Boolean,
            isBundlePackage: Boolean,
            bundlePackageSelected: Boolean,
        },
        mounted() {
            if (this.bundleItemIsSelected(this.bundle_item) || this.bundle_item.is_mandatory === '1') {
                this.toggleThirdPartyEquipment(this.bundle_item);
            }
        },
        computed: {
            featureDictionary: function () {
                let feature_dictionary = {};
                let featureList = this.bundle_item.hasOwnProperty('service_features') && this.bundle_item.service_features ?
                    this.bundle_item.service_features: [];
                featureList.forEach(feature => {
                    if (feature.value && feature.value.includes(",")) {
                        feature.value = feature.value.split(",")[0];
                    }
                    feature_dictionary[feature['feature_api_code']] = feature;
                });
                return feature_dictionary;
            },
            baxNumber: function () {
                if (!!this.featureDictionary) {
                    return this.featureDictionary[this.baxNumberApiCode];
                }
                return null;
            },
            baxEffectiveDate: function () {
                if (!!this.featureDictionary) {
                    return this.featureDictionary[this.baxEffectiveDateApiCode];
                }
                return null;
            },
        },
        methods: {
            itemHasDescription: function (bundle_item) {
                return bundle_item.service.hasOwnProperty('service_description') &&
                    bundle_item.service.service_description !== '';
            },
            itemIsDisabled: function (bundle_item) {
                return this.isView ? true : this.isBundlePackage ? true : this.equipmentIsDisabled(bundle_item);
            },
            toggleThirdPartyEquipment: function (bundle_item) {
                if (bundle_item.is_boarding_activated === '1'  || bundle_item.is_mandatory === '1') {
                    bundle_item.terminal_quantity = 1;
                    bundle_item.selected = true;
                    this.selectItem(this.baxNumberApiCode);
                    if (bundle_item.service_charges) {
                        bundle_item.service_charges.forEach(service_charge => service_charge.selected = '1');
                    }
                    //this.selectItem(this.baxEffectiveDateApiCode);
                    this.$emit('third-party-equipment-toggled', bundle_item);
                }
                else {
                    bundle_item.terminal_quantity = 0;
                    bundle_item.selected = false;
                    if (bundle_item.service_features) {
                        bundle_item.service_features.forEach(feature => {
                            feature.disabled = true;
                            //unset feature value if collected from user
                            if (feature.collect_on_boarding === this.collect_on_boarding_types.BOARDING){
                                feature.value = '';
                                feature.selected = '';
                            }
                        });
                    }
                    if (bundle_item.service_charges) {
                        bundle_item.service_charges.forEach(service_charge => service_charge.selected = '');
                    }
                }
            },
            selectItem: function (item, is_required = false) {
                if (this.featureDictionary.hasOwnProperty(item)) {
                    //set value on select
                    this.featureDictionary[item]['value'] = !!this.featureDictionary[item]['value'] ?
                        this.featureDictionary[item]['value'] :
                        (this.featureDictionary[item].hasOwnProperty('collect_on_value') ?
                            this.featureDictionary[item]['collect_on_value'] : this.featureDictionary[item]['default_value']);

                    //set the disabled field based on collect_on_boarding
                    this.setFeatureDisabledFlag(item);

                    this.featureDictionary[item]['selected'] = '1';

                    if (!!is_required){
                        this.featureDictionary[item]['required'] = true;
                    }
                }
            },
            setFeatureDisabledFlag: function (item){
                if (this.featureDictionary.hasOwnProperty(item)) {
                    //set the disabled field based on collect_on_boarding
                    if (this.featureDictionary[item]['collect_on_boarding'] === this.collect_on_boarding_types.OFFER) {
                        this.featureDictionary[item]['disabled'] = true
                    } else if (this.featureDictionary[item]['collect_on_boarding'] === this.collect_on_boarding_types.CONFIG) {
                        this.featureDictionary[item]['disabled'] = true;
                    } else {
                        this.featureDictionary[item]['disabled'] = false;
                    }
                }
            },
            isSelectedFeature: function (feature_api_code) {
                return this.featureDictionary.hasOwnProperty(feature_api_code) && this.featureDictionary[feature_api_code]['selected'] === '1';

            },
            itemIsSelected: function (bundle_item) {
                return this.isBundlePackage ? this.bundlePackageSelected ? '1' : '0' : this.equipmentIsSelected(bundle_item);
            },
            getServiceChargeDescription: function (service_charge) {
                return service_charge.service_item_name + ' - ' + this.getServiceCharge(service_charge) + (service_charge.service_frequency !== '1' ? `/${this.formatServiceFrequency(service_charge.service_frequency)}` : '');
            },
            getFeatureValue: function (feature) {
                let feature_value = !!feature.value ? feature.value : feature.default_value;

                if (feature.feature_input_type === this.types.LIST) {
                    let feature_list = this.getFeatureList(feature);
                    let matched_value = feature_list.find(obj => obj.id === feature_value);

                    return !!matched_value ? `(${matched_value.text})` : '';
                } else {
                    return feature_value !== '' ? `(${feature_value})` : '';
                }
            }
        }
    }
</script>

<style scoped>
    ul:not(.nav-pills) {
        list-style: none;
    }

    li:not(.nav-item) {
        font-weight: lighter;
        font-size: 0.8em;
    }

    li:not(.nav-item):before {
        content: "\f054"; /* FontAwesome Unicode fa-chevron-right*/
        font-family: 'Font Awesome 5 Free';
        font-weight: 900;
        display: inline-block;
        margin-left: -1.3em; /* same as padding-left set on li */
        width: 1.3em; /* same as padding-left set on li */
    }

    /*.avatar-small:hover {*/
    /*    box-shadow: 0 0 2px 1px rgba(66, 153, 225, 1);*/
    /*    -ms-transform: scale(2.5); !* IE 9 *!*/
    /*    -webkit-transform: scale(2.5); !* Safari 3-8 *!*/
    /*    transform: scale(2.5);*/
    /*    cursor: pointer;*/
    /*    z-index: 99999;*/
    /*}*/

    .vue-radio-checkbox.np-checkbox.default.form-group {
        min-height: 0 !important;
    }


</style>
